export default {
    methods: {
        toggleLogin () {
            this.$store.dispatch('User/toggleLoginBox')
        },
        closeLogin (e) {
            this.$store.dispatch('User/setLoginBox', this.getAllowedElementsToCloseLoginOn(e))
        },
        logout () {
            this.$store.dispatch('logout')
            this.$router.push({ name: 'home' }).catch(err => {})
            this.$store.dispatch('User/toggleLoginBox')
        },
        goToKnowledgeCenter () {
            window.open(this.$t('StoreMenu.knowledge_center_url'), '_blank')
            this.$store.dispatch('User/toggleLoginBox')
        },
        goToUserManagement () {
            window.location.href = `${window.location.protocol}//${window.location.host}/admin/userManagement`
        },
        getAllowedElementsToCloseLoginOn (e) {
            return (
                this.$el.contains(e.target) &&
                !e.target.classList.contains('login__link'))
                || e.target.classList.contains('agreement-form__link')
                || e.target.classList.contains('trial-form-thank-you__login')
        },
    }
}
